module.exports = __webpack_public_path__ + "static/shoe-purple-025bed08830353c8310f6530948266e9.png";